import config from "../../config";
import { actionTypes } from "./actions";

const initialState = {
    appBarTitle: "",
    drawerOpen: false,
    paginationRowsPerPage: config.pagination.rowsPerPageOptions[0],
    auditsTabValue: 0
};

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.APP_SETTINGS_SET: {
            const { appSettings } = action.payload;
            return { ...state, ...appSettings };
        }
        default: {
            return state;
        }
    }
}
